const initstate = {
  classic2Products: [],
  real2Products: [],
  gift1Products: [],
  product: [],
  zhNoodlesAdv: {},
  zhSauceAdv: {},
  zhEvaluateAdv: {},
  johnsHomeAdv: {},
};

export function johnsState(state = initstate, action) {
  switch (action.type) {
    case 'GET_CLASSIC_PRODUCTS': {
      return {
        ...state,
        classic2Products: action.payload,
      };
    }
    case 'GET_REAL_PRODUCTS': {
      return {
        ...state,
        real2Products: action.payload,
      };
    }
    case 'GET_GIFT_PRODUCTS': {
      return {
        ...state,
        gift1Products: action.payload,
      };
    }
    case 'GET_PRODUCTS': {
      return {
        ...state,
        product: action.payload,
      };
    }
    case 'GET_ZHNOODLES_ADV': {
      return {
        ...state,
        zhNoodlesAdv: action.payload,
      };
    }
    case 'GET_ZHSAUCE_ADV': {
      return {
        ...state,
        zhSauceAdv: action.payload,
      };
    }
    case 'GET_ZHEVALUATE_ADV': {
      return {
        ...state,
        zhEvaluateAdv: action.payload,
      };
    }
    case 'GET_JOHNS_HOME_ADV': {
      return {
        ...state,
        johnsHomeAdv: action.payload,
      };
    }
    default:
      return state;
  }
}

export default johnsState;
